function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 17.1V8.6C15 6.1 16.9 4 19.4 4h1c-1.7.9-2.4 2.8-2.4 4.6V21h-6c0-1.9 1.3-3.4 3-3.9zm-4 0c-1.7.4-3 2-3 3.9h3v-.6c.2-1.8 1.4-3.3 3-3.9V8.6c0-1.8.7-3.7 2.4-4.6h-1C12.9 4 11 6.1 11 8.6v8.5zm-4 0c-2.3.3-4 1.9-4 3.9h4v-2.4V21c0-1.2.4-2.3 1.1-3.1l.4-.4c.4-.4.9-.8 1.5-1V8.6c0-1.8.7-3.7 2.4-4.6h-1C8.9 4 7 6.1 7 8.6v8.5z",
  fill: "currentColor"
});

var SvgLocationWaterfall = function SvgLocationWaterfall(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationWaterfall;